(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["klaviyo-back-in-stock"] && !Shopify.designMode) return;
  try {
    
(function () {
  function BackInStockSection(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.klaviyoKey = container.dataset.klaviyoKey;
    this.errorMessage = container.dataset.errorMessage || 'Something went wrong. Please try again.';
    this.variantMap = {};

    var dataEl = document.getElementById('bis-variants-' + this.sectionId);
    if (dataEl) {
      try {
        JSON.parse(dataEl.textContent).forEach(function (v) {
          this.variantMap[v.id] = v.available;
        }, this);
      } catch (e) {}
    }

    this.form = container.querySelector('.bis-form');
    this.successMsg = container.querySelector('.bis-message--success');
    this.errorMsg = container.querySelector('.bis-message--error');
    this.submitBtn = container.querySelector('[type=submit]');
    this.productForm = document.querySelector('form[action*="/cart/add"]');
    this.variantInput = this.productForm
      ? this.productForm.querySelector('input[name=id]')
      : document.querySelector('input[name=id]');

    this._bind();

    if (this.variantInput) {
      this._updateVisibility(parseInt(this.variantInput.value, 10));
    } else {
      this.container.style.display = 'none';
    }
  }

  BackInStockSection.prototype._bind = function () {
    var self = this;

    if (this.variantInput) {
      this.variantInput.addEventListener('change', function () {
        self._updateVisibility(parseInt(self.variantInput.value, 10));
      });
    }

    document.addEventListener('variant:changed', function (e) {
      if (e.detail && e.detail.variant) {
        self._updateVisibility(e.detail.variant.id);
      }
    });

    if (this.productForm) {
      this.productForm.addEventListener('change', function () {
        var input = self.productForm.querySelector('input[name=id]');
        if (input) self._updateVisibility(parseInt(input.value, 10));
      });
    }

    this.form.addEventListener('submit', function (e) {
      self._handleSubmit(e);
    });
  };

  BackInStockSection.prototype._updateVisibility = function (variantId) {
    var unavailable = this.variantMap[variantId] === false;
    this.container.style.display = unavailable ? '' : 'none';
    this._togglePurchaseControls(!unavailable);
  };

  BackInStockSection.prototype._togglePurchaseControls = function (show) {
    if (!this.productForm) return;

    var selectors = [
      '.quantity__wrapper',
      '.product-form__quantity',
      '.quantity-selector',
      'quantity-input',
      '[data-quantity-wrapper]',
      '.product-form__submit',
      '.product-form__buttons',
      '.product__submit'
    ];

    var seen = [];
    selectors.forEach(function (sel) {
      try {
        this.productForm.querySelectorAll(sel).forEach(function (el) {
          if (seen.indexOf(el) === -1) seen.push(el);
        });
      } catch (e) {}
    }, this);

    seen.forEach(function (el) {
      el.style.display = show ? '' : 'none';
    });
  };

  BackInStockSection.prototype._handleSubmit = function (e) {
    e.preventDefault();

    var emailInput = this.form.querySelector('[name=email]');
    var email = emailInput ? emailInput.value.trim() : '';
    var variantId = this.variantInput ? this.variantInput.value : null;

    if (!email || !variantId || !this.klaviyoKey) return;

    this.submitBtn.disabled = true;
    this.successMsg.hidden = true;
    this.errorMsg.hidden = true;
    this.errorMsg.textContent = '';

    var self = this;

    fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
        encodeURIComponent(this.klaviyoKey),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + variantId
                }
              }
            }
          }
        })
      }
    )
      .then(function (res) {
        if (res.ok || res.status === 202) {
          emailInput.value = '';
          self.form.hidden = true;
          self.successMsg.hidden = false;
        } else {
          throw new Error('failed');
        }
      })
      .catch(function () {
        self.errorMsg.textContent = self.errorMessage;
        self.errorMsg.hidden = false;
        self.submitBtn.disabled = false;
      });
  };

  document.querySelectorAll('.bis-section').forEach(function (el) {
    new BackInStockSection(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
